import './assets/main.css'
// Import our custom CSS
import './assets/scss/styles.scss'
import './assets/sass/app.scss'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import {
  faArrowRight,
  faLock,
  faShareNodes,
  faDownload,
  faCirclePlay,
  faSearch,
  faArrowDown,
  faTableCellsLarge,
  faPlus,
  faPause,  
  faCircleCheck,
  faMinus,
  faPlay,
  faAngleRight,
  faAngleLeft,
  faChevronLeft,
  faUser,
  faThumbsUp,
  faAnglesRight,
  faTrash,
  faBars,
  faCloudArrowDown,
  faClipboard,
  faUpDownLeftRight

} from '@fortawesome/free-solid-svg-icons'
import { faCommentDots, faClock, faBookmark, faFolder, faCircle } from '@fortawesome/free-regular-svg-icons'

/* add icons to the library */
library.add(
  faArrowRight,
  faCommentDots,
  faClock,
  faLock,
  faBookmark,
  faShareNodes,
  faDownload,
  faCirclePlay,
  faSearch,
  faArrowDown,
  faTableCellsLarge,
  faFolder,
  faPlus,
  faPause,
  faCircleCheck,
  faMinus,
  faPlay,
  faAngleRight,
  faAngleLeft,
  faChevronLeft,
  faCircle,
  faUser,
  faThumbsUp,
  faAnglesRight,
  faTrash,
  faBars,
  faCloudArrowDown,
  faClipboard,
  faUpDownLeftRight  
)

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'

import App from '@/App.vue'
import router from 'router/index'
import VueCookies from 'vue3-cookies'
import Tabs from 'vue3-tabs'
import VueAwesomePaginate from 'vue-awesome-paginate'
import VueCollapsiblePanel from '@dafcoe/vue-collapsible-panel'
import { vMaska } from 'maska'
import { LoadingPlugin } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import GoogleSignInPlugin from "vue3-google-signin"

import VueGtag from 'vue-gtag'
import { createHead, VueHeadMixin } from '@unhead/vue'
const head = createHead()


// import the necessary css file
import 'vue-awesome-paginate/dist/style.css'
import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'

const pinia = createPinia()
pinia.use(piniaPersist)

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(VueCookies)
app.use(Tabs)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(VueAwesomePaginate)
app.use(VueCollapsiblePanel)
app.directive('maska', vMaska)
app.use(LoadingPlugin);
app.use(head)
app.mixin(VueHeadMixin)

app.use(VueGtag, {
  appName: 'Bella da Semana',
  pageTrackerScreenviewEnabled: true,
  config: {
    id: 'G-2ZXCPBB1C3'
  }
}, router)

app.use(GoogleSignInPlugin, {
  clientId: '52066769961-422kailit22s7br2vg24mgihe30r0f84.apps.googleusercontent.com'
});

app.mount('#app')
